// ** React Imports
import React, { useEffect, useState } from "react";
import {
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import SetPricingComponent from "./SetPricingView";
import InventoryCapping from "./InventoryCappingView";
import SetOnlineView from "./SetOnlineView";
import UpdateRatesView from "./UpdateRatesView";
// import { DropdownOptions } from "../constants/InventoryConstants";
import {
  getAllNonHiddenRoomTypes,
  getAllNonHiddenRoomTypesWithHotelId,
} from "../api/InventoryApi";
import CommonSlider from "../../CalendarPage/Views/CommonSlider";
import OpenCloseView from "./OpenCloseViews";
import { connect } from "react-redux";
import { handleSpringDataRequest } from "../../../api";
import { cloneDeep } from "lodash";
import i18n from "../../../modules/Auth/pages/i18n";
import { useTranslation } from "react-i18next";
import ShowOfflineRooms from "./ShowOfflineRooms";
import GroupSetPricingView from "./GroupSetPricingView";
import GroupInventoryCappingView from "./GroupInventoryCappingView";
import GroupSetOnlineView from "./GroupSetOnlineView";
import GroupUpdateRatesView from "./GroupUpdateRatesView";
import GroupOpenCloseViews from "./GroupOpenCloseViews";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  textField: {
    padding: theme.spacing(2),
  },
  linerProgress: {
    marginBottom: theme.spacing(2),
    width: "100%",
    "& > * + *": {
      marginop: theme.spacing(2),
    },
  },
  header: {
    padding: theme.spacing(2),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
    },
  },
};

const GroupRightDrawer = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);

  const DropdownOptions = [
    { text: `${t("Set Pricing")}`, val: "set-price" },
    { text: `${t("Set Inventory")}`, val: "set-inventory" },
    { text: `${t("Rate Multiplier")}`, val: "rate-multiplier" },
    { text: `${t("Inventory Capping")}`, val: "inventory-cap" },
    { text: `${t("Set Online")}`, val: "set-online" },
    { text: `${t("Set Offline")}`, val: "set-offline" },
    { text: `${t("Block Rooms")}`, val: "block-room" },
    { text: `${t("Unblock Rooms")}`, val: "unblock-room" },
    { text: `${t("Delete Rooms")}`, val: "delete-room" },
    { text: `${t("Restore Deleted Rooms")}`, val: "restore" },
    { text: `${t("Update Rates from OTA")}`, val: "update-ota" },
    { text: `${t("Set Sold Out")}`, val: "sold-out" },
    { text: `${t("Edit Room Ids")}`, val: "edit-room" },
    { text: `${t("Reassign Room Type")}`, val: "reassign" },
    { text: `${t("Close/Open Rate Plan")}`, val: "Close Rate" },
    { text: `${t("Close/Open Room Type")}`, val: "Close Room" },
    { text: `${t("Close/Open On Arrival")}`, val: "Close On Arrival" },
    { text: `${t("Close/Open On Departure")}`, val: "Close On Departure" },
    { text: `${t("Min Length of Stay")}`, val: "Set Min Los" },
    { text: `${t("Max Length of Stay")}`, val: "Set Max Los" },
    { text: `${t("Min Advanced Booking Offset")}`, val: "Set Cutoff" },
    { text: `${t("Max Advanced Booking Offset")}`, val: "Set Max Adv Offset" },
    // { text: `${t("Show offline rooms")}`, val: "Show offline rooms" },
  ];

  const EditRateAccess = true;

  const EditInevntoryAccess = true;

  const [rooms, setRooms] = React.useState();
  const [selectedRoom, setSelectedRoom] = useState("");
  const [actionType, setActionType] = useState(
    EditRateAccess
      ? "set-price"
      : EditInevntoryAccess
      ? "set-inventory"
      : "edit-room"
  );
  const [dataLoading, setDataLoading] = useState(true);
  const [showLine, setShowLine] = useState(false);
  const classes = useStyles();
  const { handleAddEventSidebar, open, refresh, activeHotels } = props;

  const [hoteldata, sethoteldata] = useState({});

  const [selectedHotelId, setselectedHotelId] = useState(
    activeHotels[0].hotelId
  );

  const setLineVisible = () => {
    setShowLine(true);
  };

  const setLineInvisible = () => {
    setShowLine(false);
  };

  const isOnlineComponent = (selectType) => {
    if (
      selectType === "set-online" ||
      selectType === "set-offline" ||
      selectType === "block-room" ||
      selectType === "unblock-room" ||
      selectType === "delete-room" ||
      selectType === "edit-room" ||
      "sold-out"
    ) {
      return true;
    }
    return false;
  };

  const getActionName = (name) => {
    const item = DropdownOptions.find((option) => option.val === name);
    return item.text;
  };

  const intialFunc = async () => {
    setLineVisible();
    setDataLoading(true);
    let resp = await getAllNonHiddenRoomTypesWithHotelId(selectedHotelId);
    setSelectedRoom(Object.keys(resp)[0]);
    setRooms(resp);
    setDataLoading(false);
  };

  useEffect(() => {
    intialFunc();
    getAccessControl();
  }, [selectedHotelId]);

  const getAccessControl = () => {
    handleSpringDataRequest(
      `core/api/v1/accesscontrol/addUserWizardRender?email=${localStorage.getItem(
        "HotelEmail"
      )}&hotelId=${activeHotels[0].hotelId}&hotel_id=${activeHotels[0].hotelId}`
    )
      .then((res) => {
        sethoteldata(res.hotel);
      })
      .catch((err) => console.error(err));
  };

  const [roomAndPlans, setroomAndPlans] = useState([]);

  useEffect(() => {
    const fetchRoomData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SPRING_API_URL}core/api/v1/room/get-all-roomtype-obj-noAuth?hotelId=${selectedHotelId}&hotel_id=${selectedHotelId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setroomAndPlans(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchRoomData();
  }, [selectedHotelId]);

  const [AccessControl, setAccessControl] = useState([
    {
      EditRateAccess: new Set([
        `${t("Set Pricing")}`,
        `${t("Rate Multiplier")}`,
        `${t("Update Rates from OTA")}`,
        `${t("Min Advanced Booking Offset")}`,
        `${t("Max Advanced Booking Offset")}`,
      ]),
    },
    {
      EditInevntoryAccess: new Set([
        `${t("Set Inventory")}`,
        `${t("Inventory Capping")}`,
        `${t("Set Offline")}`,
        `${t("Set Online")}`,
        `${t("Unblock Rooms")}`,
        `${t("Block Rooms")}`,
        `${t("Set Sold Out")}`,
        `${t("Reassign Room Type")}`,
        `${t("Close/Open Room Type")}`,
        `${t("Close/Open Rate Plan")}`,
        `${t("Close/Open On Arrival")}`,
        `${t("Close/Open On Departure")}`,
        `${t("Min Length of Stay")}`,
        `${t("Max Length of Stay")}`,
        `${t("Delete Rooms")}`,
        `${t("Restore Deleted Rooms")}`,
        `${t("Edit Room Ids")}`,
        // `${t("Show offline rooms")}`,
      ]),
    },
  ]);

  return (
    <div className={classes.root}>
      <CommonSlider
        open={open}
        onClose={() => {
          handleAddEventSidebar();
        }}
      >
        <Grid container>
          <Grid container item xs={12} className={classes.header}>
            <Grid
              container
              xs={10}
              spacing={2}
              justifyContent="flex-start"
              item
            >
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {t("Hotels")}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    onChange={(e) => setselectedHotelId(e.target.value)}
                    className="mr-4"
                    label={t("Hotels")}
                    value={selectedHotelId}
                  >
                    {activeHotels?.map((item) => (
                      <MenuItem
                        value={item.hotelId}
                      >{`${item.hotelName} - ${item.hotelId}`}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {t("Action Type")}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={actionType}
                    label={t("Action Type")}
                    title={getActionName(actionType)}
                    onChange={(eve) => {
                      if (isOnlineComponent(eve.target.value)) {
                        setSelectedRoom("all-rooms");
                      }
                      if (
                        selectedRoom === "all-rooms" &&
                        !isOnlineComponent(eve.target.value)
                      ) {
                        setSelectedRoom(Object.keys(rooms)[0]);
                      }
                      if (eve.target.value === "Show offline rooms") {
                        setSelectedRoom(Object.keys(rooms)[0]);
                      }
                      setActionType(eve.target.value);
                    }}
                    MenuProps={MenuProps}
                  >
                    {DropdownOptions.map((name) => {
                      if (EditRateAccess) {
                        if (AccessControl[0]["EditRateAccess"].has(name.text)) {
                          return (
                            <MenuItem key={name.text} value={name.val}>
                              {name.text}
                            </MenuItem>
                          );
                        }
                      }
                      if (EditInevntoryAccess) {
                        if (
                          AccessControl[1]["EditInevntoryAccess"].has(name.text)
                        ) {
                          return (
                            <MenuItem key={name.text} value={name.val}>
                              {name.text}
                            </MenuItem>
                          );
                        }
                      }
                    })}
                  </Select>
                </FormControl>
              </Grid>
              {!dataLoading && (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <FormControl fullWidth>
                    <InputLabel
                      hidden={
                        actionType === "rate-multiplier" ||
                        actionType === "inventory-cap" ||
                        actionType === "Set Max Adv Offset" ||
                        actionType === "Set Cutoff" ||
                        actionType === "Set Max Los" ||
                        actionType === "Set Min Los" ||
                        actionType === "Close On Departure" ||
                        actionType === "Close On Arrival" ||
                        actionType === "Close Room" ||
                        actionType === "Close Rate" ||
                        actionType === "set-inventory" ||
                        actionType === "set-price"
                      }
                      id="demo-simple-select-label"
                    >
                      {t("Room Types")}
                    </InputLabel>
                    <Select
                      disabled={
                        actionType === "sold-out" ||
                        actionType === "update-ota" ||
                        actionType === "edit-room"
                      }
                      labelId="demo-simple-select-label"
                      onChange={(eve) => {
                        setSelectedRoom(eve.target.value);
                      }}
                      hidden={
                        actionType === "rate-multiplier" ||
                        actionType === "inventory-cap" ||
                        actionType === "Set Max Adv Offset" ||
                        actionType === "Set Cutoff" ||
                        actionType === "Set Max Los" ||
                        actionType === "Set Min Los" ||
                        actionType === "Close On Departure" ||
                        actionType === "Close On Arrival" ||
                        actionType === "Close Room" ||
                        actionType === "Close Rate" ||
                        actionType === "set-inventory" ||
                        actionType === "set-price"
                      }
                      id="demo-simple-select"
                      value={selectedRoom}
                      label={t("Room Types")}
                      MenuProps={MenuProps}
                    >
                      {actionType === "sold-out" &&
                        actionType !== "Show offline rooms" && (
                          <MenuItem key="all-rooms" value={"all-rooms"}>
                            {t("All Rooms")}
                          </MenuItem>
                        )}
                      {actionType !== "sold-out" &&
                        actionType !== "Show offline rooms" &&
                        isOnlineComponent(actionType) && (
                          <MenuItem key="all-rooms" value={"all-rooms"}>
                            {t("All Rooms")}
                          </MenuItem>
                        )}
                      {Object.keys(rooms).map((name) => (
                        <MenuItem key={name} value={name}>
                          {rooms[name]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </Grid>
            <Grid container xs={2} item justifyContent="flex-end">
              <IconButton title="close" onClick={handleAddEventSidebar}>
                <Close />
              </IconButton>
            </Grid>
          </Grid>
          {showLine && <LinearProgress className={classes.linerProgress} />}
          {!showLine && <Divider sx={{ width: "100%", marginBottom: 2 }} />}

          {!dataLoading && (
            <Grid sx={{ width: "100%", height: "100%" }} container>
              {actionType === "set-price" && (
                <GroupSetPricingView
                  data={props.data}
                  componentType="set-price"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  roomAndPlanscopy={cloneDeep(roomAndPlans)}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                />
              )}
              {actionType === "set-inventory" && (
                <GroupSetPricingView
                  data={props.data}
                  componentType="set-inventory"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                />
              )}
              {actionType === "rate-multiplier" && (
                <GroupInventoryCappingView
                  componentType="rate-multiplier"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  roomAndPlans={roomAndPlans}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}
              {actionType === "inventory-cap" && (
                <GroupInventoryCappingView
                  componentType="inventory-cap"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  roomAndPlans={roomAndPlans}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}
              {actionType === "set-online" && (
                <GroupSetOnlineView
                  data={props.data}
                  componentType="set-online"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "set-offline" && (
                <GroupSetOnlineView
                  data={props.data}
                  componentType="set-offline"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "block-room" && (
                <GroupSetOnlineView
                  data={props.data}
                  componentType="block-room"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "unblock-room" && (
                <GroupSetOnlineView
                  data={props.data}
                  componentType="unblock-room"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "delete-room" && (
                <GroupSetOnlineView
                  data={props.data}
                  componentType="delete-room"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "restore" && (
                <GroupSetOnlineView
                  data={props.data}
                  componentType="restore"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "sold-out" && (
                <GroupUpdateRatesView
                  data={props.data}
                  componentType="sold-out"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "update-ota" && (
                <GroupUpdateRatesView
                  data={props.data}
                  componentType="update-ota"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "reassign" && (
                <GroupSetOnlineView
                  data={props.data}
                  componentType="reassign"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "edit-room" && (
                <GroupUpdateRatesView
                  data={props.data}
                  componentType="edit-room"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "Close Rate" && (
                <GroupOpenCloseViews
                  componentType="Close Rate"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "Close Room" && (
                <GroupOpenCloseViews
                  componentType="Close Room"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "Close On Arrival" && (
                <GroupOpenCloseViews
                  componentType="Close On Arrival"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "Close On Departure" && (
                <GroupOpenCloseViews
                  componentType="Close On Departure"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "Set Min Los" && (
                <GroupOpenCloseViews
                  componentType="Set Min Los"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "Set Max Los" && (
                <GroupOpenCloseViews
                  componentType="Set Max Los"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "Set Cutoff" && (
                <GroupOpenCloseViews
                  componentType="Set Cutoff"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}

              {actionType === "Set Max Adv Offset" && (
                <GroupOpenCloseViews
                  componentType="Set Max Adv Offset"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}
              {actionType === "Show offline rooms" && (
                <ShowOfflineRooms
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  refresh={refresh}
                  setLineInvisible={setLineInvisible}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  selectedLanguage={props.selectedLanguage}
                  hotelId={selectedHotelId}
                  hoteldata={hoteldata}
                />
              )}
            </Grid>
          )}
        </Grid>
      </CommonSlider>
    </div>
  );
};

export default GroupRightDrawer;
